import request from '@/utils/request'

const getList = (data) => {
  const { name, detail, readerFirstname, readerLastname, page, limit, sort } = data

  let query = `page=${page + 1}&limit=${limit}&sortBy=${sort.field}&orderBy=${sort.type}`
  if(name) query += `&name=${encodeURI(name)}`
  if(detail) query += `&detail=${encodeURI(detail)}`
  if(readerFirstname) query += `&readerFirstname=${encodeURI(readerFirstname)}`
  if(readerLastname) query += `&readerLastname=${encodeURI(readerLastname)}`
  return request({
    url: `/api/articles?${query}`,
    method: 'get'
  })
}

export default {
  getList
}
